import React from 'react';

export default function TeamProjectsGList_UserCounts(record: any) {

    return (
        <div className="flex-row-left-center">
            <div className="i5-users"></div>
            <div className="ui5-txt-less-important m-l-10">{record.model.usersTotal}</div>
        </div>
    );
}
